<script lang="ts">
  import type { Snippet } from 'svelte';
  import { registerDialog, unregisterDialog, isTopmostDialog } from './dialog-stack.js';

  let {
    children,
    onClose,
    variant = 'modal',
  }: {
    children: Snippet;
    onClose: () => void;
    variant?: 'modal' | 'sheet';
  } = $props();

  const { id, z } = registerDialog();

  $effect(() => () => unregisterDialog(id));

  function onKeydown(e: KeyboardEvent) {
    if (e.key !== 'Escape') return;
    if (!isTopmostDialog(id)) return;
    onClose();
  }
</script>

<svelte:window onkeydown={onKeydown} />

<div class="scrim-wrap variant-{variant}" style="z-index: {z};">
  <button type="button" class="scrim" aria-label="Close" onclick={onClose}></button>
  {@render children()}
</div>

<style>
  .scrim-wrap {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
  }
  .variant-modal {
    align-items: center;
    padding: 1rem;
  }
  .variant-sheet {
    align-items: flex-end;
  }
  @media (min-width: 768px) {
    .variant-sheet {
      align-items: center;
      padding: 1rem;
    }
  }
  .scrim {
    position: absolute;
    inset: 0;
    background: rgba(31, 29, 26, 0.32);
    border: 0;
    cursor: pointer;
  }
  .variant-sheet .scrim {
    background: rgba(31, 29, 26, 0.42);
  }
</style>
